import styled from 'styled-components';
import { h4Styles } from '~typography';
var BodyParts = styled.span.withConfig({
  displayName: "BodyParts",
  componentId: "sc-55qm4g-0"
})(["", " text-transform:capitalize;"], h4Styles);
export default BodyParts;